const $inject = ['$scope', '$filter', 'timesService', 'ENUMS', 'dateTimeService'];

const lbTimeSelectCtrl = function ($scope, $filter, timesService, ENUMS, dateTimeService) {
  let vm = this;

  const TIME_FORMAT = dateTimeService.getFormat(ENUMS.dateTimeFormats.TIME_LONG);

  vm.times = timesService.getSelectOptions(TIME_FORMAT, true);
  vm.inputName = `${vm.name}.${vm.index}`;

  vm.selectedTime = vm.time;

  $scope.$watch('vm.selectedTime', (selectedTime) => {
    vm.time = selectedTime;
  });
};

lbTimeSelectCtrl.$inject = $inject;

export default lbTimeSelectCtrl;



// WEBPACK FOOTER //
// ./src/components/lbTimeSelect/lbTimeSelectCtrl.js